import React, { useState, useRef, useEffect } from "react";

// Main FilterPopover component
function FilterPopover({ locations, filters, onFilterChange }) {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef(null);

  const handleChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      const clickedInsidePopover =
        popoverRef.current && popoverRef.current.contains(event.target);
      const clickedInDropdown =
        event.target.closest(".dropdown-portal") !== null;

      if (!clickedInsidePopover && !clickedInDropdown) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="relative inline-block" ref={popoverRef}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="px-4 py-2 bg-white border rounded-lg shadow-sm flex items-center gap-2 hover:bg-gray-100 text-gray-800"
      >
        <span className="font-medium">Filters</span>
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-[400px] bg-white border p-4 rounded-xl shadow-lg z-40 space-y-4">
          {/* Status */}
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              className="w-full border rounded px-2 py-1 text-sm"
              value={filters.status}
              onChange={(e) => handleChange("status", e.target.value)}
            >
              <option value="all">All</option>
              <option value="employed">Employed</option>
              <option value="archived">Archived</option>
            </select>
          </div>

          {/* Location */}
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Location
            </label>
            <select
              className="w-full border rounded px-2 py-1 text-sm"
              value={filters.location}
              onChange={(e) => handleChange("location", e.target.value)}
            >
              <option value="All">All</option>
              {locations.map((loc) => (
                <option key={loc.id} value={loc.id}>{loc.name}</option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterPopover;
